import Vue from 'vue'
import VueI18n from 'vue-i18n'
// 引入element ui自带语言包
import ElementUILocale from 'element-ui/lib/locale' 
import elementEnLocale from 'element-ui/lib/locale/lang/en' // element-ui lang
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'// element-ui lang
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
    ...elementEnLocale
  },
  zh: {
    ...zhLocale,
    ...elementZhLocale
  }
}

const i18n = new VueI18n({
  // set locale
  // options: en | zh | es
    locale: localStorage.LANGUAGE || navigator.language,
  // set locale messages
  messages,
  silentTranslationWarn: true
})

export const setElementLanguage = lang => {
 // Vue.config.lang = lang 
    if(lang=='en'){
        ElementUILocale.use(elementEnLocale) // element ui 切换语言
  }else{
        ElementUILocale.use(elementZhLocale) // element ui 切换语言
  }
 
}

setElementLanguage(localStorage.LANGUAGE|| navigator.language)
export default i18n
